import script from "./SucaiDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SucaiDetail.vue?vue&type=script&setup=true&lang=js"

import "./SucaiDetail.vue?vue&type=style&index=0&id=d3b060ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3b060ee"]])

export default __exports__